import { render, staticRenderFns } from "./msgToast.vue?vue&type=template&id=553caeaa&"
import script from "./msgToast.vue?vue&type=script&lang=js&"
export * from "./msgToast.vue?vue&type=script&lang=js&"
import style0 from "./msgToast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports